module.exports = __webpack_public_path__ + "static/media/nerit.16706eae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_minha-central/Footer/nerit.svg
// module id = 1440
// module chunks = 0